import React, { useEffect } from "react";

const CustomLoader = () => {
  useEffect(() => {
    const handleLoad = () => {
      const preloader = document.getElementById("preloader");
      if (preloader) {
        preloader.classList.add("loaded");
      }
    };
    window.addEventListener("load", handleLoad);
    return () => window.removeEventListener("load", handleLoad);
  }, []);

  return (
    <>
      <style>{`
        #preloader {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background-color: rgba(0, 0, 0, 0.3); /* transparent dark tint */
          backdrop-filter: blur(5px); /* blur effect */
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 999;
          transition: opacity 0.6s ease, visibility 0.6s ease;
        }

        #preloader.loaded {
          opacity: 0;
          visibility: hidden;
        }

        .loader {
          animation: rotate 1s infinite;
          height: 50px;
          width: 50px;
        }

        .loader:before,
        .loader:after {
          border-radius: 50%;
          content: "";
          display: block;
          height: 20px;
          width: 20px;
        }

        .loader:before {
          animation: ball1 1s infinite;
          background-color: #fff;
          box-shadow: 30px 0 0 #ff3d00;
          margin-bottom: 10px;
        }

        .loader:after {
          animation: ball2 1s infinite;
          background-color: #ff3d00;
          box-shadow: 30px 0 0 #fff;
        }

        @keyframes rotate {
          0% { transform: rotate(0deg) scale(0.8); }
          50% { transform: rotate(360deg) scale(1.2); }
          100% { transform: rotate(720deg) scale(0.8); }
        }

        @keyframes ball1 {
          0% { box-shadow: 30px 0 0 #ff3d00; }
          50% {
            box-shadow: 0 0 0 #ff3d00;
            margin-bottom: 0;
            transform: translate(15px, 15px);
          }
          100% {
            box-shadow: 30px 0 0 #ff3d00;
            margin-bottom: 10px;
          }
        }

        @keyframes ball2 {
          0% { box-shadow: 30px 0 0 #fff; }
          50% {
            box-shadow: 0 0 0 #fff;
            margin-top: -20px;
            transform: translate(15px, 15px);
          }
          100% {
            box-shadow: 30px 0 0 #fff;
            margin-top: 0;
          }
        }
      `}</style>

      <div id="preloader">
        <div className="loader"></div>
      </div>
    </>
  );
};

export default CustomLoader;
